/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useEffect, useState } from "react";
import { ImageSelector } from "cms/images/image-selector";

const ImageSelectorWrapper = (props) => {

    const _image = props?.image;
    const onImageChange = props?.onImageChange;
    const onImageSave = props?.onImageSave;
    const onImageRemove = props?.onImageRemove;
    const debug = props?.debug;
    const AddButtonComponent = props?.AddButtonComponent; // optional
    const DisplayComponent = props?.DisplayComponent; // optional
    const onReload = props?.onReload;
    const className = props?.className;
    const defaultImageSelectorWidth = props?.defaultImageSelectorWidth;
    const defaultImageSelectorHeight = props?.defaultImageSelectorHeight;

    const [image, setImage] = useState(_image);

    useEffect(() => {
        setImage(_image?.url ? _image : undefined);
    }, [_image]);
    
    const onSelectImage = async (image) => {
        setImage(image);
        onImageChange(image);
    };
    
    const onSaveImage = async (image) => {
        setImage(image);
        onImageSave(image);
        onImageChange(image);
    };
    
    const onImageRemoved = async (image) => {
        onImageRemove(image);
    };
    
    const onImageDeleted = async () => {}; // disabled here for now

    return (
        <div className={`simplicity-image-editor ${className}`}>
            <div className='simplicity-image-editor-view'>
                <div className='image-display'>
                    <ImageSelector
                        image={image}
                        setImage={setImage}
                        onSelectImage={onSelectImage.bind(this)}
                        onSaveImage={onSaveImage.bind(this)}
                        onImageRemoved={onImageRemoved.bind(this)}
                        onImageDeleted={onImageDeleted.bind(this)}
                        AddButtonComponent={AddButtonComponent}  // optional
                        DisplayComponent={DisplayComponent} // optional
                        debug={debug}
                        onReload={onReload}
                        defaultImageSelectorWidth={defaultImageSelectorWidth}
                        defaultImageSelectorHeight={defaultImageSelectorHeight}
                    />
                </div>
            </div>
        </div>
    );
};

export { ImageSelectorWrapper };
